import { useMutation } from "@apollo/client"
import { TOURNAMENT_PLAYER_REGISTER } from "../queries/tournamentPlayerRegister"

export interface TournamentPlayerRegisterInput {
  tournamentId: number
  personId: number
  raceId?: number
  documentType?: string
  documentNumber?: string
}

export const useTournamentPlayerRegister = () => {
  const [registerPlayer, { loading, error }] = useMutation(TOURNAMENT_PLAYER_REGISTER)

  const registerTournamentPlayer = async (input: TournamentPlayerRegisterInput) => {
    try {
      const { data } = await registerPlayer({
        variables: {
          TournamentPlayerRegisterInput: input,
        },
      })
      return data?.TournamentPlayerRegister
    } catch (err) {
      console.error("Error registering tournament player:", err)
      throw err
    }
  }

  return {
    registerTournamentPlayer,
    loading,
    error,
  }
}
